module.exports = __webpack_public_path__ + "static/img/cd_yl.8e088251.png";